import { render, staticRenderFns } from "./ShowPracticePulseDetails.vue?vue&type=template&id=2451f7bb&scoped=true"
import script from "./ShowPracticePulseDetails.vue?vue&type=script&lang=js"
export * from "./ShowPracticePulseDetails.vue?vue&type=script&lang=js"
import style0 from "./ShowPracticePulseDetails.vue?vue&type=style&index=0&id=2451f7bb&prod&scoped=true&lang=scss"
import style1 from "./ppdetailsstyles.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451f7bb",
  null
  
)

export default component.exports